//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import { SocialNetworkIcon } from '@components/molecules/SocialNetworkIcon';
import { SocialNetwork } from '@models/SocialNetwork';
import { navigateToState } from '@react-bridge/wrappers/navigation';
import { recordEvent } from '@tracker/tracker';
import { TRACKING_ACTION, TRACKING_CATEGORY } from '@tracker/trackerModel';
import { pxStrToNum } from '@utils/styleUtils';
import { OnboardingStepCard } from '@welcome-page/components/onboarding/steps/OnboardingStepCard';
import { OnboardingState } from '@welcome-page/components/onboarding/steps/OnboardingStepCardGrid';
import { ONBOARDING_STEP_ICON_SIZE } from '@welcome-page/constants/OnboardingConstants';

export const OnboardingSocialCard = ({ isError, status }: OnboardingState) => {
  const handleSocialConnection = () => {
    recordEvent(
      TRACKING_CATEGORY.SHOPIFY_ONBOARDING,
      TRACKING_ACTION.CONNECT_ACCOUNT,
      'Instagram',
    );
    void navigateToState('account-settings.social', {});
  };

  const iconSize = pxStrToNum(ONBOARDING_STEP_ICON_SIZE);

  return (
    <OnboardingStepCard
      description="Connect your brand's social media accounts to get started."
      icons={[
        <SocialNetworkIcon
          key='instagram-logo'
          size={iconSize}
          socialNetwork={SocialNetwork.Instagram}
        />,
        <SocialNetworkIcon
          key='tiktok-logo'
          size={iconSize}
          socialNetwork={SocialNetwork.TikTok}
        />,
        <SocialNetworkIcon
          key='facebook-logo'
          size={iconSize}
          socialNetwork={SocialNetwork.Facebook}
        />,
        <SocialNetworkIcon
          key='pinterest-logo'
          size={iconSize}
          socialNetwork={SocialNetwork.Pinterest}
        />,
        <SocialNetworkIcon
          key='x-logo'
          size={iconSize}
          socialNetwork={SocialNetwork.Twitter}
        />,
      ]}
      onClickConnect={handleSocialConnection}
      showAlarmTooltip={isError}
      status={status}
      title='Social'
    />
  );
};
